import { render, staticRenderFns } from "./line5.vue?vue&type=template&id=a2963b42&scoped=true&"
import script from "./line5.vue?vue&type=script&lang=js&"
export * from "./line5.vue?vue&type=script&lang=js&"
import style0 from "./line5.vue?vue&type=style&index=0&id=a2963b42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2963b42",
  null
  
)

export default component.exports